import React from 'react'
import './services.css';
import { BiCheck } from 'react-icons/bi';
export default function Services() {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className='container services__container'>
        <artile className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;HTML & CSS Responsive Web Design</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;React JS Development</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Node.js Development</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Javascript Development</p>
          </li>
        </artile>
        {/* END OF WEB DEVELOPMENT */}
        <artile className="service">
          <div className="service__head">
            <h3>Web Scrape</h3>
          </div>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Extract data from dynamic web sites. Make better predictions and decisions.</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Real time scraping</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Big data scraping</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Automated scraping scripts</p>
          </li>
          <li className="service__list">
            <p><BiCheck className='service__list-icon' />&nbsp;Turn any website into an API</p>
          </li>
        </artile>
        {/* END OF web scrape */}
      </div>
    </section>
  )
}
